'use es6';

import { List } from 'immutable';
import { listOf } from 'react-immutable-proptypes';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import classNames from 'classnames';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorMultiStringInput = ({
  className,
  'data-selenium-test': seleniumSelector,
  error,
  onChange,
  onBlur,
  value
}) => {
  const onBlurLocal = () => {
    if (typeof onBlur === 'function') {
      onBlur();
    }
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: error.get('error'),
    validationMessage: error.get('error') ? error.get('message') : null,
    children: /*#__PURE__*/_jsx(UISelect, {
      allowCreate: true
      //arrowRender is an 'undocumented' property for UISelect.
      // This is being hacked as a Select-arrow with 0 opacity to satisfy hiding the arrow,
      // but allowing Acceptance Test utilities which depend on it to continue to work.
      // visibilty:hidden, display:none are all not options because ATs will not interect with hidden elements.
      ,
      arrowRenderer: () => /*#__PURE__*/_jsx("div", {
        className: "Select-arrow",
        style: {
          opacity: 0
        }
      })
      // UISelects without an anchor type must use className selenium selectors
      ,
      className: classNames(className, seleniumSelector),
      multi: true,
      noResultsText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterOperatorMultiStringInput.resultsText"
      }),
      onBlur: onBlurLocal,
      onChange: evt => onChange(SyntheticEvent(List(evt.target.value))),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterOperatorMultiStringInput.placeholder"
      }),
      promptTextCreator: userInput => unescapedText('customerDataFilters.FilterOperatorMultiStringInput.promptText', {
        value: userInput
      }),
      value: value && value.toArray() || []
    })
  });
};
FilterOperatorMultiStringInput.propTypes = {
  className: PropTypes.string,
  'data-selenium-test': PropTypes.string.isRequired,
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: listOf(PropTypes.string)
};
export default FilterOperatorMultiStringInput;